import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import TopControlPanel from "../../components/TopControl/TopControlPanel";
import { NAVIGATION_STREAM } from "../../services/Navigation/navigateTo.hoc";
import NavigationEventDTO from "../../services/Navigation/NavigationEventDTO";

const actionsCreators: ActionsCreators<{
    sendBackAction: () => NavigationEventDTO;
}> = {
    sendBackAction: {
        creator: () => ({ route: "BACK", parameters: {} }),
        name: NAVIGATION_STREAM
    }
};

export default connectToJava({
    actionsCreators,
    state: {},
    stateMapper: () => ({})
})(TopControlPanel);
